// extracted by mini-css-extract-plugin
export default {"products":"pC-z","card":"qC-z","oosMessaging":"rC-z"};